import { isNumeric, fastInnerText } from './renderer-helper'

declare var numbro

export const dropdownNumericRenderer = (instance: Object, td: HTMLElement, row: number, col: number, prop: any, value: string, cellProperties: any) =>{
  if (isNumeric(value)) {
    var numericFormat = cellProperties.numericFormat;
    var cellCulture = numericFormat && numericFormat.culture;
    var cellFormatPattern = numericFormat && numericFormat.pattern;
    var className = cellProperties.className || '';
    var classArr = className.length ? className.split(' ') : [];

    if (typeof cellCulture !== 'undefined') {
      numbro.culture(cellCulture);
    }
    var formatValue = numbro(value).format(cellFormatPattern || '0');
    if (classArr.indexOf('htLeft') < 0 && classArr.indexOf('htCenter') < 0 && classArr.indexOf('htRight') < 0 && classArr.indexOf('htJustify') < 0) {
      classArr.push('htRight');
    }
    if (classArr.indexOf('htNumeric') < 0) {
      classArr.push('htNumeric');
    }
    td.className = classArr.join(' ');
    cellProperties.className = classArr.join(' ');
    if(!cellProperties.source.find(v =>{ return Number(v) == Number(value)})){
      td.className += ' htInvalid'
      cellProperties.className += ' htInvalid'
    } else {
      td.className = td.className.replace(/ htInvalid/g, '')
      cellProperties.className = cellProperties.className.replace(/ htInvalid/g, '')
    }
    fastInnerText(td, formatValue);
  }
}



// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/plugins/dropdown-helper.ts